import { Attributes } from "@lib/enums/ProductAttributes";

function getPdpVariantSizeAttributeNames(): string[] {
    return ["Size", "Size_US", "Size_UK", "Size_JP", "Size_KR", "Size_CA", "Size_CN"];
}

export function getPdpVariantAttributesToInclude(): string[] {
    return [
        ...getPdpVariantSizeAttributeNames(),
        Attributes.sizeSuggestion,
        Attributes.VariantNumber,
        Attributes.EAN,
        Attributes.EAN13,
        Attributes.Gtin13,
        Attributes.Gtin,
        Attributes.Barcode,
        Attributes.VariantGrossWeight,
        Attributes.VariantWeightUnit,
        Attributes.VariantDimensionOuterWidth,
        Attributes.VariantDimensionOuterHeight,
        Attributes.VariantDimensionOuterLength,
        Attributes.VariantDimensionUnit,
        Attributes.VariantSizeUS,
        Attributes.VariantSizeUK,
        Attributes.sizeUS,
        Attributes.sizeUK,
    ];
}
